import DEVICE_STATUS from "./status";

export const MAP_DEVICE_STATUS = {
  OK: DEVICE_STATUS.OK,
  ALARM: DEVICE_STATUS.ALARM,
  WARNING: DEVICE_STATUS.WARNING,
  ERROR: DEVICE_STATUS.ERROR,
  THRESHOLD: "threshold",
  // Maintenance is not deployed yet
  // added for future use and requested by the manager rn
  MAINTENANCE: "maintenance"
};

export const MAP_DEVICE_STATUSES = [
  MAP_DEVICE_STATUS.OK,
  MAP_DEVICE_STATUS.ALARM,
  MAP_DEVICE_STATUS.WARNING,
  MAP_DEVICE_STATUS.ERROR,
  MAP_DEVICE_STATUS.THRESHOLD,
  MAP_DEVICE_STATUS.MAINTENANCE
];

// Priority: ALARM > THRESHOLD > OK
export const getMapStatus = device => {
  if (device.status === DEVICE_STATUS.ALARM) {
    return MAP_DEVICE_STATUS.ALARM;
  }

  if (device.thresholdStatus) {
    return MAP_DEVICE_STATUS.THRESHOLD;
  }

  return device.status;
};
